const certificates = {
  title: "Expertise",
  new_certificate: "New expertise",
  edit_certificate: "Edit expertise: {name}",
  view_certificate: "View expertise: {name}",
  name: "Title",
  user_id: "User",
  issued_date: "Issued Date",
  issued_by: "Certificate issued by",
  issued_by_vat: "Certificate issued by company ID",
  company: "Certification company name",
  documents: "Documents",
  filename: "Filename",
  mime: "Mime",
  path: "Path",
  size: "Size",
  deleted_on: "Deleted on",
  removed_on: "Removed on",
  select_files: "Select files to upload",
  save_first: "Please save first the certificate before uploading documents.",
  expertise: "Expertise",
  expertise_proof: "Expertise list",
  info_link: "Info Link",
  valid_until: "Valid until",
  course_held_by: "Course held by",
  classes: "Classes",
  coursetypes: "Course Types",
  student: "Student",
  add_title: "Add new title",
  new_title_required: "Please enter an additional title.",
  coursetypegroup_id: "Course Type Group",
  note: "Note",
  moduletemplates: "Modules",
  expired: "Expired",
  file_upload_note:
    "Note: Make sure to upload both sides of plastic card/expertise proof.",
}
export default certificates
